var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConversationFilterRemoveIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.78516 1.43005C8.42326 1.43005 10.5703 3.5771 10.5703 6.21521C10.5703 8.85332 8.42326 11.0004 5.78516 11.0004C3.14705 11.0004 1 8.85332 1 6.21521C1 3.57711 3.14705 1.43006 5.78516 1.43005Z",
    fill: "black",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0098 7.0199C10.6356 9.46928 8.57975 11.3655 6.05762 11.4935C8.57635 11.3651 10.6351 9.46579 11.0098 7.01892V7.0199ZM0.560547 7.01892C0.908547 9.29136 2.709 11.0918 4.98145 11.4398L5.24512 11.473C2.84632 11.2296 0.921368 9.38207 0.560547 7.0199V7.01892ZM5.24512 0.957397C2.84934 1.20155 0.921903 3.05187 0.560547 5.4115L0.527344 5.67517C0.770807 3.27638 2.6183 1.35143 4.98047 0.990601L5.24512 0.957397ZM6.05762 0.93689C8.57975 1.06496 10.6356 2.96114 11.0098 5.41052L11.043 5.67517C10.7808 3.1023 8.6661 1.06993 6.05762 0.93689Z",
    fill: "black",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.62699 4.37207L3.94299 8.05607M3.94299 4.37207L7.62699 8.05607",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversationFilterRemoveIcon);
export default __webpack_public_path__ + "static/media/conversation-filter-remove-icon.71905c89f443bd9beabb5d646472a105.svg";
export { ForwardRef as ReactComponent };